import Dashboard from './components/Dashboard';
import { combineReducers } from 'redux';
import dashboardReducers from './reducers/dashboardReducers';
import usersReducers from './reducers/usersReducers'

const components = { Dashboard };

const reducers = combineReducers({
    dashboard: dashboardReducers,
    users: usersReducers,
});
export { components, reducers };
